<template>
  <v-container v-if="Donor" class="pa-0" grid-list-lg fluid>
    <!-- <v-alert
      v-if="Donor"
      border="left"
      type="error"
      tile
      transition="slide-y-transition"
      dismissible
      class="mb-2"
      v-model="Donor.alert"
      color="red"
    >
      <strong>{{ Donor.note }}</strong>
    </v-alert> -->
    <Edit v-if="Donor" :editDialog="editDialog" @close="editDialog = false" @submit="loadData" :editDonor="Donor">
    </Edit>

    <!-- <ParentInvoiceCreate
      :createDialog="createParentInvoiceDialog"
      @close="createParentInvoiceDialog = false"
      :parent="Donor"
    ></ParentInvoiceCreate> -->
    <!-- @close="assignClose"
      @submit="getList" -->

    <v-card tile v-if="Donor">
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title class="text-capitalize">
          {{ Donor.name }}
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list class="menu-button">
            <!-- <div v-if="checkRightStatus(6)">
              <v-list-item
                v-if="$vuetify.breakpoint.xsOnly"
                @click="newInvoice"
              >
                <v-list-item-title>New Invoice</v-list-item-title>
              </v-list-item>
            </div> -->
            <v-list-item v-if="checkRightStatus(23)" @click="editDialog = true">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <DeleteDonor :donor="Donor" @submit="$router.go(-1)" />
            <v-list-item @click="viewOpenInvoice()">
              <v-list-item-title>View Open Invoice</v-list-item-title>
            </v-list-item>
            <SyncBalance :DonorId="Donor.id" />
            <Statement :CustomerId="Donor.id" />
            <v-divider></v-divider>
            <!-- <SearilSearch /> -->
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout class="mt-5" v-if="!Donor" align-center justify-center column fill-height>
          <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate"></v-progress-circular>
          <div>Loading...</div>
        </v-layout>
        <v-layout row wrap v-else justify-space-between>
          <v-flex shrink>
            <v-layout row v-if="Donor.name">
              <!-- <v-flex shrink>
                <v-img width="50" src="@/assets/islamic.png"></v-img>
              </v-flex> -->
              <v-flex shrink>
                <div class="text-capitalize" v-if="Donor.name">
                  {{ Donor.name }}
                </div>
                <div class="text-capitalize" v-if="Donor.phoneNumber">
                  {{ Donor.phoneNumber }}
                </div>
                <div v-if="Donor.email">
                  {{ Donor.email }}
                </div>
              </v-flex>
              <v-flex xs12 v-if="Donor.donationInitiated">
                <v-chip small>Online Created</v-chip>
              </v-flex>
            </v-layout>

            <span v-if="!$vuetify.breakpoint.xsOnly">
              <v-btn class="mt-2" color="primary" v-if="checkRightStatus(6)" @click="newInvoice">New Invoice</v-btn>
            </span>
            <div class="mt-2" v-if="Donor.stripeId">
              <a style="text-decoration: none;" :href="`https://dashboard.stripe.com/customers/${Donor.stripeId}`"
                target="_blank">
                <v-chip label color="blue" text-color="white">
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>
                  Stripe
                </v-chip>
              </a>

            </div>
            <div class="mt-2" v-if="Donor.payCompassId" @click="readSecret">
              <v-chip label color="yellow" text-color="black">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Online
              </v-chip>

            </div>
          </v-flex>

          <v-spacer></v-spacer>

          <v-flex shrink>
            <div class="text-right">
              <v-tooltip bottom v-if="Donor.address">
                <template v-slot:activator="{ on }">
                  <a v-on="on" @click="openGoogleMap">
                    <div class="text-capitalize title">
                      {{ Donor.address }}
                    </div>
                    <div class="text-capitalize">
                      {{ Donor.city }}, {{ Donor.state }}
                      {{ Donor.zip }}
                    </div>
                  </a>
                </template>
                <span>Click to open google map</span>
              </v-tooltip>

              <div class="mt-1">
                <span class="font-weight-medium">Donor Since: </span>
                <span>{{ Donor.createdAt | moment("from", "now") }}</span>
              </div>

              <div class="mt-3" v-if="checkRightStatus(33)">
                <div class="text-capitalize title">Balance</div>
                <div :style="{ color: balanceColor }" class="text-capitalize font-weight-light display-3">
                  {{ Donor.balance | currency }}
                </div>
                <!-- <div>Limit: {{ Donor.balanceLimit | currency }}</div> -->
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-tabs v-model="active" slider-color="primary" color="black" show-arrows grow>
      <v-tab>{{ $t("labels.dashboard") }}</v-tab>
      <!-- <v-tab>Statistics</v-tab> -->
      <!-- <v-tab>Order</v-tab> -->
      <!-- <v-tab>Students</v-tab> -->
      <v-tab>Payment Collection</v-tab>
      <!-- <v-tab>Payment Method</v-tab> -->
      <v-tab>Invoice</v-tab>
      <v-tab>Payments</v-tab>
      <v-tab>Subscription</v-tab>
      <v-tab>Attachment</v-tab>
    </v-tabs>
    <v-tabs-items background-color="transparent" v-model="active" touchless="touchless">
      <v-tab-item>
        <Dashboard :Donor="Donor"> </Dashboard>
      </v-tab-item>
      <!-- <v-tab-item>
        <Statistics> </Statistics>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <OrderList v-if="Donor" :CustomerId="Donor.id"> </OrderList>
      </v-tab-item> -->
      <!-- <v-tab-item> -->
      <!-- <StudentList v-if="Donor" :CustomerId="Donor.id" /> -->
      <!-- <InvoiceList
          :due="true"
          :showAll="true"
          v-if="Donor"
          :CustomerId="Donor.id"
        >
        </InvoiceList> -->
      <!-- </v-tab-item> -->
      <v-tab-item>
        <PaymentMethodReminderList v-if="Donor" :donor="Donor" :DonorId="Donor.id">
        </PaymentMethodReminderList>
      </v-tab-item>
      <!-- <v-tab-item>
        <PaymentMethod v-if="Donor" :donor="Donor" :DonorId="Donor.id">
        </PaymentMethod>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <InvoiceList v-if="Donor" :CustomerId="Donor.id"> </InvoiceList>
      </v-tab-item> -->

      <v-tab-item>
        <InvoiceList :showAll="true" v-if="Donor" :DonorId="Donor.id">
        </InvoiceList>
      </v-tab-item>
      <v-tab-item>
        <PaymentList v-if="Donor" :DonorId="Donor.id"> </PaymentList>
      </v-tab-item>
      <v-tab-item>
        <Subscription v-if="Donor" :DonorId="Donor.id">
        </Subscription>
      </v-tab-item>
      <v-tab-item>
        <AttachmentList v-if="Donor" TypeId="2" :RelationId="Donor.id">
        </AttachmentList>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
const Dashboard = () => import("../components/Dashboard");
const PaymentMethodReminderList = () =>
  import("@/modules/Donors/PaymentInfoCollect/PaymentMethod.vue");
// const PaymentMethod = () =>
//   import("@/modules/Donors/PaymentMethod/components/List.vue");
const InvoiceList = () => import("@/modules/Invoice/components/List.vue");
const AttachmentList = () => import("@/modules/Attachment/components/List");
// const OrderList = () => import("@/modules/Order/InHouse/components/List");
const PaymentList = () => import("@/modules/Invoice/Payment/components/List.vue");
const DeleteDonor = () => import("../components/DeleteDonor");
// const RemoteOrderLink = () => import("@/components/RemoteOrderLink");
const SyncBalance = () => import("@/modules/Donors/components/syncBalance.vue");
const Subscription = () => import("@/modules/Subscription/components/List.vue");
const Statement = () => import("@/modules/Donors/components/Statement");
// const ParentInvoiceCreate = () =>
//   import("@/modules/Customer/components/ParentInvoiceCreate.vue");

// const SearilSearch = () =>
//   import("@/modules/Customer/components/ImeiSearch.vue");

import { mapGetters, mapActions } from "vuex";

import Hashids from "hashids";
const hashids = new Hashids();

const Edit = () => import("@/modules/Donors/components/Edit");
import donorService from "@/modules/Donors/service.js";

export default {
  name: "customer-profile",
  data() {
    return {
      createParentInvoiceDialog: false,
      fab: false,
      active: null,
      editDialog: false,
      Donor: null,
    };
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadData();
      }
    },
  },
  components: {
    Edit,
    SyncBalance,
    Subscription,
    Dashboard,
    Statement,
    PaymentMethodReminderList,
    // PaymentMethod,
    InvoiceList,
    AttachmentList,
    PaymentList,
    // OrderList,
    DeleteDonor,
    // ParentInvoiceCreate,
    // Statistics,
    // SearilSearch,
  },
  created() {
    this.loadData();
    this.$events.listen("customerProfileEvent", () => {
      console.log("listen enve")
      // this.$events.emit("invoiceListEvent");
      // this.$events.emit("paymentListEvent");
      // this.$events.emit("studentListEvent");
      // this.$events.emit("subscriptionListEvent");
      this.loadData()
    });
  },
  beforeDestroy() {
    this.$events.remove("customerProfileEvent");
  },
  computed: {
    // ...mapGetters("customer", ["Donor"]),
    ...mapGetters("global", ["checkRightStatus"]),
    balanceColor() {
      let color = "black";
      if (this.Donor.balance > this.Donor.balanceLimit) {
        color = "red";
      } else {
        color = "green";
      }

      return color;
    },
  },
  methods: {
    ...mapActions("customer", ["setCustomer"]),
    ...mapActions("global", ["setPageTitle"]),
    readSecret() {
      return donorService
        .readSecret(this.Donor.id)
        .then((response) => {
          // this.Donor = response.data;
          console.log('secret response', response)
        })
        .catch(() => {
          this.$Progress.finish();
        });
      // donorService.readSecret(this.Donor.id).then(response => {
      //   console.log('secret response', response)
      // })
    },
    viewOpenInvoice() {
      const hashId = hashids.encode(this.Donor.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/openInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    newInvoice() {
      this.$router.push({
        path: `/invoice/create?DonorId=${this.Donor.id}`,
      });
    },
    async loadData() {
      let id = this.$route.params.id;
      this.$Progress.start();
      return donorService
        .getById(id)
        .then((response) => {
          this.Donor = response.data;
          console.log('response.data.alert', response)
          document.title = `taleem - ${this.Donor.name}`
          // if (response.data && !response.data.alert) response.data.alert = false
          this.$Progress.finish();
        })
        .catch(() => {
          this.$Progress.finish();
        });

      // await this.setCustomer(id);
      // this.setPageTitle(this.Donor.name);
      // console.log("Donor", this.Donor);
    },
    openGoogleMap() {
      window.open(
        `https://www.google.com/maps/place/${this.Donor.address} ${this.Donor.city},${this.Donor.state} ${this.Donor.zip}`,
        "_blank"
      );
    },
    sendEmail() {
      let routeData =
        "https://mail.google.com/mail/?view=cm&fs=1&to=" + this.Donor.email;
      window.open(routeData, "newwindow", "width=800, height=950");
    },
    closeEdit() {
      this.editDialog = false;
    },
    updated() {
      this.closeEdit();
      this.loadData();
    },
  },
};
</script>
